module.exports = __webpack_public_path__ + "img/redTulip.e5779597.jpg";